import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cx-spinner',
  templateUrl: './cx-spinner.component.html',
  styleUrls: ['./cx-spinner.component.scss']
})
export class CxSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
